/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum EdiOutboundInvoiceKind {
  Invoice = "invoice",
  Credit = "credit",
  Correction = "correction",
}

export function instanceOfEdiOutboundInvoiceKind(value: any): boolean {
  for (const key in EdiOutboundInvoiceKind) {
    if (Object.prototype.hasOwnProperty.call(EdiOutboundInvoiceKind, key)) {
      if (
        EdiOutboundInvoiceKind[key as keyof typeof EdiOutboundInvoiceKind] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EdiOutboundInvoiceKindFromJSON(
  json: any,
): EdiOutboundInvoiceKind {
  return EdiOutboundInvoiceKindFromJSONTyped(json, false);
}

export function EdiOutboundInvoiceKindFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EdiOutboundInvoiceKind {
  return json as EdiOutboundInvoiceKind;
}

export function EdiOutboundInvoiceKindToJSON(
  value?: EdiOutboundInvoiceKind | null,
): any {
  return value as any;
}

export function EdiOutboundInvoiceKindToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EdiOutboundInvoiceKind {
  return value as EdiOutboundInvoiceKind;
}
